import { cn } from '@virginexperiencedays/tailwind';

import { Button } from '../../layout/Button';
import { IconPlus } from '../../icons/IconPlus';
import { IconMinus } from '../../icons/IconMinus';
import { IconBin } from '../../icons/IconBin';

import { useUpdateQuantity } from './hooks/useUpdateQuantity';

import { GREETINGS_CARD_SKUS } from '../../constants/greetingsCardSkus';

export type QuickBasketQuantityInputProps = {
  id: string;
  sku: string;
  qty: number;
  className?: string;
};

export const QuickBasketQuantityInput = ({
  id,
  sku,
  qty,
  className,
}: QuickBasketQuantityInputProps) => {
  const { handleUserInput, minBasketItems, maxBasketItems, userInputQty } = useUpdateQuantity(
    id,
    qty
  );

  const isGreetingsCard = GREETINGS_CARD_SKUS.has(sku.toLowerCase());

  return (
    <div
      data-testid="quantity-input"
      className={cn(
        'bg-background-elevation-base border-border-neutral text-neutral flex rounded border',
        className
      )}
    >
      <Button
        className="bg-background-elevation-base p-1"
        variant="invisible"
        onClick={() => handleUserInput(-1)}
        data-testid="subtract-quantity"
      >
        {userInputQty <= minBasketItems + 1 ? (
          <IconBin className="text-neutral" />
        ) : (
          <IconMinus className="text-neutral" />
        )}
      </Button>
      <div
        data-testid="quantity"
        className="bg-background-elevation-base border-border-neutral flex h-full w-8 min-w-[20px] items-center justify-center self-center border-x p-1 text-center text-sm font-medium leading-none"
      >
        {userInputQty}
      </div>
      <Button
        className="bg-background-elevation-base p-1"
        variant="invisible"
        onClick={() => handleUserInput(1)}
        disabled={userInputQty >= maxBasketItems || isGreetingsCard}
        data-testid="add-quantity"
      >
        <IconPlus className="text-neutral" />
      </Button>
    </div>
  );
};
